
import Vue from 'vue';

/**
 * Checkboxes are used for a list of options where a user may select multiple or none at all.
 */
export default Vue.extend({
    name: 'IrisCheckbox',
    model: {
        prop: 'isChecked',
        event: 'checkbox-change',
    },
    props: {
        /**
         * The text label for the checkbox.
         */
        label: String,
        /**
         * Prop for cases of passing initial value into component without using v-model.<br /><br />
         * Without v-model listen for event 'checkbox-change' for changes to component.
         */
        isChecked: Boolean,
        /**
         * Boolean to set checkbox to its low emphasis appearance.
         */
        isLowEmphasis: Boolean,
        /**
         * Disables the checkbox and shows the disabled state.
         */
        isDisabled: Boolean,
    },
    data() {
        return {
            selected: false,
        };
    },
    computed: {
        _determineRadius() {
            const tokenValue = getComputedStyle(document.querySelector('body') as HTMLElement).getPropertyValue('--shapeBrandedSmall').trim() || '24px 24px 24px 24px';

            const shapeMap: Record<string, string> = {
                '0 0 0 0': '0 0 0 0',
                '8px 8px 8px 8px': '2px 2px 2px 2px',
                '16px 16px 16px 16px': '4px 4px 4px 4px',
                '24px 24px 24px 24px': '4px 4px 4px 4px',
            };
            const radius = shapeMap[tokenValue] || '4px 4px 4px 4px';

            return `border-radius: ${radius};`;
        },
    },
    methods: {
        selectValue(newVal: any) {
            this.$emit('checkbox-change', newVal.target.checked);
            this.selected = newVal.target.checked;
        },
        onAfterEnterTransition() {
            (this.$refs.polyline as HTMLElement).style.cssText = this.selected
                ? 'stroke-dashoffset: 0;'
                : 'stroke-dashoffset: 24;';
        },
    },
    watch: {
        isChecked(value) {
            this.selected = value;
        },
    },
    mounted() {
        this.selected = this.isChecked;
    },
});
